import React from "react";

const Stats = (props) => {
  const convertMillion = (value) => {
    if (value > 1000000) return (value / 1000000).toFixed(1) + "M";
    else return value;
  };
  return props.header ? (
    <div className="container" id="heading">
      <p>State/UT</p>
      <p>Confirmed</p>
      <p>Recovered</p>
      <p>Deceased</p>
      <p>Tested</p>
      <p>Vaccinations</p>
    </div>
  ) : (
    <div className="container">
      <p>{props.state}</p>
      <p>{convertMillion(props.confirmed)}</p>
      <p>{convertMillion(props.recovered)}</p>
      <p>{convertMillion(props.deceased)}</p>
      <p>{convertMillion(props.tested)}</p>
      <p>{convertMillion(props.vaccinated)}</p>
    </div>
  );
};

export default Stats;
